import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../BaseUrl";

const initialState = {
  loading: false,
  rfqDtlsLoading: false,
  notificationLoading: false,
  allRequest: [],
  rfqDetails: null,
  error: "",
};

const token = localStorage.getItem("token");

const config = {
  headers: {
    Authorization: `Token ${token}`,
  },
};

export const fetchRfqRequest = createAsyncThunk(
  "fetch/rfqRequest",
  async () => {
    return axios
      .get(`${BASE_URL}/service/EndUserRFQList/`, config)
      .then((response) => response.data);
  }
);

export const fetchRfqDetails = createAsyncThunk(
  "fetch/rfqDetails",
  async (textId) => {
    console.log(`${BASE_URL}/service/EndUserRFQ/${textId}/`);
    return axios
      .get(`${BASE_URL}/service/EndUserRFQ/${textId}/`, config)
      .then((response) => response.data);
  }
);

export const sendNotification = createAsyncThunk(
  "send/sendNotification",
  async (textId) => {
    console.log(`${BASE_URL}/service/EndUserRFQNotification/${textId}/`);
    // console.log(`${BASE_URL}/service/EndUserRFQNotification/${textId}/`);
    return axios
      .get(`${BASE_URL}/service/EndUserRFQNotification/${textId}/`, config)
      .then((response) => response.data);
  }
);

const rfqRequestSlice = createSlice({
  name: "RfqRequest",
  initialState,
  extraReducers: (builder) => {
    //data handle for rfq list=====
    builder.addCase(fetchRfqRequest.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(fetchRfqRequest.fulfilled, (state, action) => {
      state.loading = false;
      state.allRequest = [];

      if (action.payload.rfqs_list) {
        action.payload.rfqs_list.forEach((item) => {
          state.allRequest.push(item);
        });
      }

      state.error = "";
    });
    builder.addCase(fetchRfqRequest.rejected, (state, action) => {
      state.loading = false;
      state.allRequest = [];
      state.error = action.error;
    });

    //data handle for rfq details======================================
    builder.addCase(fetchRfqDetails.pending, (state) => {
      state.rfqDtlsLoading = true;
    });
    builder.addCase(fetchRfqDetails.fulfilled, (state, action) => {
      state.rfqDtlsLoading = false;
      state.rfqDetails = action.payload;
      state.error = "";
    });
    builder.addCase(fetchRfqDetails.rejected, (state, action) => {
      state.rfqDtlsLoading = false;
      state.rfqDetails = null;
      state.error = action.error;
    });

    //send notification======================================
    builder.addCase(sendNotification.pending, (state) => {
      state.notificationLoading = true;
      
    });
    builder.addCase(sendNotification.fulfilled, (state, action) => {
      state.notificationLoading = false;
      // state.rfqDetails = action.payload;
      state.error = "";
    });
    builder.addCase(sendNotification.rejected, (state, action) => {
      state.rfqDtlsLoading = false;
      state.error = action.error;
    });
  },
});

export default rfqRequestSlice.reducer;
